import { Link } from '@tanstack/react-router';
import { Button } from '@sara/ui/components/button';
import { Plus } from 'lucide-react';
import { useActiveOrganization } from '../../contexts/auth';
import { ExtractionListContainer } from '../../contexts/extractions';
import { PageHeader } from '../../components/page-header';

export function ExtractionsPage() {
  const { organization } = useActiveOrganization();

  return (
    <div className="space-y-12">
      <PageHeader
        title="Extractions"
        description="Versioned extraction schemas that pull structured data from conversations."
        action={
          organization && (
            <Link to="/orgs/$orgSlug/extractions/new" params={{ orgSlug: organization.slug }}>
              <Button
                variant="tinted"
                shape="pill"
                size="sm"
                className="h-8 gap-1.5 px-3 text-xs [&_svg]:size-3.5 sm:h-9 sm:px-4 sm:text-sm sm:[&_svg]:size-4"
              >
                <Plus strokeWidth={1.6} />
                New extraction
              </Button>
            </Link>
          )
        }
      />

      {organization && <ExtractionListContainer orgId={organization.id} />}
    </div>
  );
}
